module.exports = __webpack_public_path__ + "img/82.faee19e1.jpg";